import {useEffect, useState} from "react";
import {useInView} from "react-intersection-observer";
import CasinoGroupSplide from "./splide";

const HomepageCasinoGroupItem = props => {


    const {data, title, image, path} = props
    const {ref, inView} = useInView({
        triggerOnce: true, // Mount the component only once
        threshold: 0.4, // Mount when 10% of the component is visible
    });
    const [coloredData, setColoredData] = useState([])

    useEffect(() => {
        if (inView) {
            setColoredData(data)
        }
    }, [inView, data])



    return (
        <div ref={ref} className="section">

            {
                coloredData?.length >= 1 &&
                <div className="container">
                    <CasinoGroupSplide
                        title={title}
                        data={coloredData}
                        loading={false}
                        icon={image}
                        path={`/casino/group/${path}`}

                    />
                </div>
            }
        </div>
    )

}

export default HomepageCasinoGroupItem
